var render = function render(){var _vm=this,_c=_vm._self._c;return _c('edit-dialog',{attrs:{"value":_vm.value,"id":_vm.id,"model":_vm.model,"api":_vm.api},on:{"input":function($event){return _vm.$emit('input')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }